import { useState, useEffect, useCallback } from 'react';
import { pricing as defaultPricing } from '../data/pricing';

const usePricingData = () => {
  const [pricing, setPricing] = useState(defaultPricing);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const fetchPricing = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('authToken');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

      const response = await fetch(`${API_URL}/api/pricing`, {
        headers,
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.pricing) {
          setPricing(data.pricing);
        }
        // If null (DB not seeded yet), keep the static default
      }
    } catch (err) {
      console.warn('Failed to fetch pricing catalog, using defaults:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [API_URL]);

  useEffect(() => {
    fetchPricing();
  }, [fetchPricing]);

  return { pricing, loading, error, refresh: fetchPricing, defaultPricing };
};

export default usePricingData;
